var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wizardstepjobmatchpreviousjobtitles" },
    [
      _vm.previousJobTitles !== undefined && _vm.previousJobTitles.length <= 0
        ? [
            _c("div", { staticClass: "empty-items" }, [
              _c(
                "div",
                {
                  staticClass:
                    "job-goal-item bg-white rounded py-3 px-4 soft-shadow d-flex align-items-center border border-success mr-5",
                },
                [
                  _c("b-icon", {
                    staticClass: "mr-4",
                    attrs: {
                      icon: "check",
                      "font-scale": "1.4",
                      variant: "success",
                    },
                  }),
                  _c("b-skeleton", {
                    staticClass: "mb-0 cursor-default",
                    attrs: { width: "50%", animation: "" },
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass:
                    "job-goal-item bg-white rounded py-3 px-4 soft-shadow d-flex align-items-center border border-success ml-5",
                },
                [
                  _c("b-icon", {
                    staticClass: "mr-4",
                    attrs: {
                      icon: "check",
                      "font-scale": "1.4",
                      variant: "success",
                    },
                  }),
                  _c("b-skeleton", {
                    staticClass: "mb-0 cursor-default",
                    attrs: { width: "50%", animation: "" },
                  }),
                ],
                1
              ),
            ]),
            _c(
              "div",
              {
                staticClass:
                  "button-section mt-5 d-flex flex-column align-items-center",
              },
              [
                _c("div", { staticClass: "text" }, [
                  _vm._v(" " + _vm._s(_vm.wizardstep.noPreviousJobTitlesText)),
                ]),
                _vm.profileLink &&
                _vm.wizardstep.noPreviousJobTitlesButtonText !== ""
                  ? _c(
                      "a",
                      { staticClass: "mt-4", attrs: { href: _vm.profileLink } },
                      [
                        _c(
                          "b-button",
                          {
                            staticClass: "btn btn-transparent",
                            on: {
                              click: function ($event) {
                                return _vm.buttonClicked()
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.wizardstep.noPreviousJobTitlesButtonText
                              )
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            ),
          ]
        : _vm._l(_vm.previousJobTitles, function (item, indx) {
            return _c(
              "span",
              { key: indx },
              [
                item !== undefined
                  ? _c("OccupationListItem", {
                      attrs: { item: item, source: "PreviousExperience" },
                    })
                  : _vm._e(),
              ],
              1
            )
          }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }